import { Breakpoint } from '@fcom/common/interfaces';

export const getTickPadding = (breakpoint: Breakpoint): number => {
  switch (breakpoint) {
    case 'mobile':
      return 6;
    case 'tablet':
      return 8;
    default:
      return 16;
  }
};
